import {
    Exercise,
    LabelBody,
    LabelBodyHeadline,
    LabelBodySmall,
    LabelDisplay4,
    LabelHeader4,
} from '../components';
import { ExerciseDto } from '../interfaces';

type Props = {
    exercise: ExerciseDto;
    body: string[];
};
export function ExampleView({ exercise, body }: Props) {
    return (
        <Exercise title="Eksempel">
            {exercise.ImageMetadata && (
                <>
                    <img
                        className="rounded-[10px]"
                        src={exercise.ImageMetadata.Url}
                    />
                    <LabelBodySmall class="mt-10">
                        Billedet er illustrativt
                    </LabelBodySmall>
                </>
            )}
            <LabelHeader4 class="mt-30">{exercise.Name}</LabelHeader4>
            <LabelBodyHeadline color="text-dark-red" class="mt-10">
                {exercise.Description}
            </LabelBodyHeadline>
            {body.map((x, idx) => (
                <LabelBody key={idx} className="mt-10">
                    {idx === 0 && (
                        <LabelDisplay4 class="inline-block">“</LabelDisplay4>
                    )}
                    {x}
                </LabelBody>
            ))}
        </Exercise>
    );
}
